import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { DataCell, DataRow, DataTableButton, DataTable } from '../DataTable';
import { ProjectClassificationModel, ConversionClient } from '../../../client/ApiClient';
import { Container, FormGroup, Input, Label, Button } from 'reactstrap';

interface IUIControllerRunTypesPageState {
    projectClassifications: ProjectClassificationModel[] | null
    selectedRow: number | null;
}

class UIControllerRunTypesPage extends React.Component<RouteComponentProps, IUIControllerRunTypesPageState>{
    private conversionClient: ConversionClient = new ConversionClient();

    constructor(props: Readonly<RouteComponentProps>) {
        super(props)
        this.state = {
            projectClassifications: null,
            selectedRow: null,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getProjectClassification();
    }

    getProjectClassification = () => {
        this.conversionClient.getProjectClassification()
            .then(response => {
                this.setState({ projectClassifications: response })
            })
            .catch(err => {
                console.log(err)
            })
    }

    createProjectClassification = (projectClassification: ProjectClassificationModel) => {
        this.conversionClient.postProjectClassification(projectClassification)
            .then(() => this.setState({ selectedRow: null }, () => this.getProjectClassification()))
            .catch(err => {
                console.log(err)
                this.setState({ selectedRow: null })
            })
    }

    deleteProjectClassification = (projectClassification: ProjectClassificationModel) => {
        this.conversionClient.deleteProjectClassification(projectClassification)
            .then(() => this.setState({ selectedRow: null }, () => this.getProjectClassification()))
            .catch(err => {
                console.log(err)
                this.setState({ selectedRow: null })
            })
    }

    handleChange = (index: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const dc = event.target.value;
        const projectClassifications = this.state.projectClassifications;
        const i = this.state.projectClassifications!.findIndex(v => v.id === index);
        if (event.target.name === 'description') {
            projectClassifications![i].description = dc;
        }
        else {
            projectClassifications![i].retentionDays = Number(dc);

        }
        this.setState({ projectClassifications })
}

    addEmptyClass = () => {
        const projectClassifications = this.state.projectClassifications;
        projectClassifications!.push(new ProjectClassificationModel());
        this.setState({ projectClassifications})
    }

    public render() {
        return (
            <DataTable>
                <thead>
                    <tr>
                        <th>
                            Run Type
                        </th>
                        <th>
                            Retention Days
                        </th>
                        <th>
                            <DataTableButton
                                icon='add'
                                id={"add"}
                                title={"Add"}
                                action={() => this.addEmptyClass()} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.projectClassifications && this.state.projectClassifications!
                        .map((u, i) => {
                            return (<DataRow id={u.id ? u.id.toString() : 'newId'} key={u!.id} onClick={() => this.setState({ selectedRow: i })}
                          >
                                <DataCell>
                                    {this.state.selectedRow === i ?
                                        <Input
                                            type="text"
                                            name="description"
                                            id="description"
                                            value={u.description || ''}
                                            onChange={e => this.handleChange(u.id!,e)}
                                            maxLength={50}
                                        /> :
                                        u.description || 'New Description'}
                                </DataCell>
                                <DataCell>
                                    {this.state.selectedRow === i ?
                                        <Input
                                            type="number"
                                            name="retentionDays"
                                            id="retentionDays"
                                            onChange={e => this.handleChange(u.id!, e)}
                                            value={u.retentionDays || 0}
                                        /> : u.retentionDays || 'New Retention Days'}
                                </DataCell>
                                <DataCell>
                                    {this.state.selectedRow === i ?
                                        <><DataTableButton
                                            icon='save'
                                            id={"save"}
                                            title={"Save"}
                                            action={() => this.createProjectClassification(u)} />
                                            <DataTableButton
                                                icon='delete'
                                                id={"delete"}
                                                title={"Delete"}
                                                action={() => this.deleteProjectClassification(u)} />
                                        </> : ''}
                                </DataCell>
                            </DataRow>)
                        })}
                </tbody>
            </DataTable>
        )
    }
}

export default withRouter(UIControllerRunTypesPage)